export type LookbookItem = {
  id: string;
  slug: string;
  title: string;
  caption: string;
  image: string;
  drop: string;
};

export const LOOKBOOK_DATA: LookbookItem[] = [
  {
    id: "lb-01",
    slug: "owl-dream-coat-urban",
    title: "Urban Silence",
    caption: "Wide silhouettes grounded in night concrete.",
    image:
      "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126?auto=format&fit=crop&w=1600&q=80",
    drop: "DROP 01 — NIGHT FORM",
  },
  {
    id: "lb-02",
    slug: "owl-dream-knit-street",
    title: "Still Motion",
    caption: "Movement without noise. Calm street energy.",
    image:
      "https://images.unsplash.com/photo-1520975867597-0f13a0b88e3d?auto=format&fit=crop&w=1600&q=80",
    drop: "DROP 01 — NIGHT FORM",
  },
  {
    id: "lb-03",
    slug: "owl-dream-trouser-wide",
    title: "Measured Volume",
    caption: "Form balanced through negative space.",
    image:
      "https://images.unsplash.com/photo-1503341455253-b2e723bb3dbb?auto=format&fit=crop&w=1600&q=80",
    drop: "DROP 01 — NIGHT FORM",
  },
];
